import { FC } from 'react';
import { Navigate } from 'react-router-dom';

import { useUserContext } from '@/contexts/user';

interface ArgSignupRegistrationRouteProps {
  Component: FC;
}

const RegistrationRoute: FC<ArgSignupRegistrationRouteProps> = ({
  Component,
}) => {
  const {
    isLoggedIn,
    isWaiting,
    isMember,
    isTemporaryMember,
    isDisabledMember,
  } = useUserContext();

  if (!isLoggedIn) {
    return <Navigate to="/signup" />;
  }

  // 仮会員で且つ未本確の場合、年齢・本人確認選択ページへ
  if (isTemporaryMember && isWaiting) {
    return <Navigate to="/signup/redirect" />;
  }

  if (isMember || isDisabledMember || isTemporaryMember) {
    return <Navigate to="/" />;
  }

  return <Component />;
};

export default RegistrationRoute;
